import { currentBoardState } from '../state';
import { makeRpc } from '../deepstream';

export const updateBoardTitle = async title => {
  await makeRpc('update-title', { title });
};

export const updateNode = async (circleId, data) => {
  await makeRpc('update-node', { circleId, data });
};

export const insertNode = async ({ circleId, parentId }) => {
  await makeRpc('insert-node', { circleId, parentId });
};

export const moveNode = async ({ nodeId, targetNodeId, withChildren = true }) => {
  await makeRpc('move-node', { nodeId, targetNodeId, withChildren });
};

export const deleteNode = async ({ nodeId, withChildren = true }) => {
  await makeRpc('delete-node', { nodeId, withChildren });
};

export const setDraggedNodeId = async nodeId => {
  currentBoardState.draggedNodeId.set(nodeId);
  await makeRpc('set-dragged-node', { nodeId });
};
